<template>
  <div @mouseleave="onMouseLeave" @mouseover="onMouseOver">
    <el-row style="font-size: 1.1rem;height: 33px;">
      <el-col :span="19">
        {{ data.spaceName }} - {{ data.deviceCategoryName }} - {{ data.deviceName ? data.deviceName : "全部设备" }} -
        {{ data.devicePointName ? data.devicePointName : "全部测点" }}
      </el-col>
    </el-row>
    <div style="padding: 25px 20px;">
      <el-row style="height: 230px;overflow-y: auto">
        <span :key="item.id" v-for="(item,index) in data.alarmUpgradeActionList">
          <span v-if="index < 2">
            <el-row>
              <el-col :span="5">{{ item.startTime }}分钟后</el-col>
              <el-col :span="19" style="color: #3a8ee6">每隔{{ item.intervalTime }}分钟,共{{ item.time }}次</el-col>
            </el-row>
            <el-row style="margin-top: 15px;">
              <el-col :span="5">发消息给</el-col>
              <el-col :span="19">
                <el-col :key="key" :span="24" v-for="(value,key) in item.alarmUpgradeNoticeMap">
                  {{ key }},通过<span :key="type.id" v-for="(type,index) in value">{{ type.noticeName }}<span
                    v-if="index !== value.length -1">,</span></span>方式
                </el-col>
              </el-col>
            </el-row>
            <el-row style="height: 21px;border-bottom: 1px dashed rgba(41,155,255,.5);margin-bottom: 20px;"></el-row>
          </span>
        </span>
      </el-row>
      <el-row>
        <el-col :span="18">
          共有{{ data.alarmUpgradeActionList.length }}个步骤<a @touchstart="() => openDialog(data)" @click="() => openDialog(data)"
                                                          style="color: #3a8ee6;margin-left: 10px;cursor: pointer">查看详情</a>
        </el-col>
        <el-col :span="6" class="btn-content">
          <img @touchstart="() => editData(data)" @click="() => editData(data)" alt="编辑" class="hidden btn btn-edit" ref="btnEdit"
               src="@/assets/images/icon/edit.png"
               v-show="showBtn">
          <img @touchstart="() => deleteData(data.id)" @click="() => deleteData(data.id)" alt="删除" class="hidden btn btn-delete" ref="btnDelete"
               src="@/assets/images/icon/delete.png"
               v-show="showBtn">
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import {deleteUpgrade} from "@/network/alarm-upload";

export default {
  name: "AlarmUpgradeComp",
  data() {
    return {
      showBtn: false,
      data: this.upgradeData,
    }
  },
  props: {
    upgradeData: {
      type: Object,
      default: () => {
      },
    }
  },
  methods: {
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    //删除策略
    deleteData(id) {
      this.$confirm('是否确认删除该策略', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteUpgrade(id).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功!")
              } else {
                this.$message.error("删除失败!")
              }
              this.$emit("init");
            })
          }
        }
      })
    },
    //编辑策略
    editData(data) {
      this.$emit("openDialog", "edit", data)
    },
    //查看详情按钮事件
    openDialog(alarmUpgradeActionList) {
      this.$emit("openDialog", "detail", alarmUpgradeActionList)
    },
  }
}
</script>

<style scoped>
.btn-content {
  float: right;
}
</style>
